export const AdminContactsSkeleton = () => (
  <div className="admin-contacts-page admin-skeleton" aria-hidden="true">
    <div className="admin-heading admin-contacts-heading">
      <div className="admin-contacts-heading-copy skeleton-stack">
        <span className="skeleton short" />
        <span className="skeleton title" />
        <span className="skeleton text" />
      </div>
    </div>

    <div className="admin-contacts-toolbar admin-contacts-toolbar--skeleton">
      <span className="skeleton admin-contacts-search-skeleton" />
      <div className="admin-contacts-filter-row">
        {Array.from({ length: 4 }).map((_, index) => (
          <span className="skeleton admin-contacts-chip-skeleton" key={index} />
        ))}
      </div>
    </div>

    <div className="admin-contact-list">
      {Array.from({ length: 4 }).map((_, index) => (
        <article className="admin-contact-card admin-contact-card--skeleton" key={index}>
          <div className="skeleton-stack">
            <span className="skeleton title" />
            <span className="skeleton text" />
            <span className="skeleton text short" />
          </div>
        </article>
      ))}
    </div>
  </div>
);
